import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

export class MxReportUrlDialogData {
    reportUrl: string;
    headerAuth?: boolean;
}

@Component({
    selector: 'mx-report-url-dialog',
    standalone: false,
    templateUrl: './mx-report-url-dialog.component.html',
    styleUrls: ['./mx-report-url-dialog.component.scss']
})
export class MxReportUrlDialogComponent {
    public reportUrl: string;
    public isCopied: boolean = false;
    public curlCopied: boolean = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: MxReportUrlDialogData
    ) {}

    get curlExample(): string {
        return `curl -H "X-API-Key: <YOUR_API_KEY>" "${this.reportUrl}"`;
    }

    ngOnInit(): void {
        this.reportUrl = this.data.reportUrl;
    }


    copy(reportUrlInput: HTMLInputElement): void {
        reportUrlInput.select();
        document.execCommand('copy');
        reportUrlInput.setSelectionRange(0, 0);
        this.isCopied = true;
    }

    copyCurl(curlInput: HTMLTextAreaElement): void {
        const value = this.curlExample;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(value).then(() => this.curlCopied = true);
            return;
        }
        curlInput.select();
        document.execCommand('copy');
        curlInput.setSelectionRange(0, 0);
        this.curlCopied = true;
    }
}
